export default __webpack_public_path__ + "static/media/rainforest.23b1c8eb.svg";